(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('FunzioneDetailController', FunzioneDetailController);

    FunzioneDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Funzione', 'RuoloFunzione'];

    function FunzioneDetailController($scope, $rootScope, $stateParams, previousState, entity, Funzione, RuoloFunzione) {
        var vm = this;

        vm.funzione = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ordiniApp:funzioneUpdate', function(event, result) {
            vm.funzione = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
